<!-- <div class="Navbar">
    <div class="Navbar__Link Navbar__Link-brand" onclick="gscholar()">
      Website title
    </div>
    <div class="Navbar__Link">
      Link
    </div>
    <div class="Navbar__Link">
      Link
    </div>
    <div class="Navbar__Link">
      Link
    </div>
    <div class="Navbar__Link">
      Link
    </div>
    <div class="Navbar__Link">
      Link
    </div>
  </div>

  <div> 
    <iframe target="_parent" type="text/html" [src] = "sanitizer.bypassSecurityTrustResourceUrl(url1)" width="800px" height="600px"></iframe>

 </div> -->

<div class="parent">
  <div class="parent1"> 
    
 <div class="card 1" >
    <div class="card_image"  (click)="gscholar();" > <img src="https://media.giphy.com/media/jAYUbVXgESSti/giphy.gif" /> </div>
    <div class="card_title title-white">
      <p style="color: black;">Google scholar</p>
    </div>
  </div>
  <div class="card 1" (click)="gsearch();">
    <div class="card_image"> <img src="https://media.giphy.com/media/3oKGzFba1fQEuthrkQ/giphy.gif" /> </div>
    <div class="card_title title-white">
      <p style="color: black;">google search</p>
    </div>
  </div>
  <div class="card 1" (click)="khana();">
    <div class="card_image"> <img src="https://media.giphy.com/media/1zhqVGkBjb0ZwfdHiC/giphy.gif" /> </div>
    <div class="card_title title-white">
      <p style="color: black;">Khan Academy</p>
    </div>
  </div>
  </div>
  <div class="parent1"> 
  <div class="card 1" (click)="quora();">
    <div class="card_image"> <img src="https://media.giphy.com/media/Ay0HHRZfnTIYYXKkzj/giphy.gif" /> </div>
    <div class="card_title title-white">
      <p style="color: black;">Quora</p>
    </div>
  </div>
  <div class="card 1"(click)="youtube();">
    <div class="card_image"> <img src="https://media.giphy.com/media/gjNpNqwG5H8oRYfZFe/giphy.gif" /> </div>
    <div class="card_title title-white">
      <p>Youtube</p>
    </div>
  </div>
  <div class="card 1" (click)="wikipedia();">
    <div class="card_image"> <img src="https://media.giphy.com/media/l7GBQWmAdtLzkjGEiF/giphy.gif" /> </div>
    <div class="card_title title-white">
      <p>Wikipedia</p>
    </div>
  </div>
</div> 
</div> 


<!-- <div (click)="gscholar()">
<div class="card 1" click="wikipedia();">
  <div class="card_image"> <img src="https://media.giphy.com/media/l7GBQWmAdtLzkjGEiF/giphy.gif" /> </div>
  <div class="card_title title-white">
    <p>Wikipedia</p>
  </div>
</div></div>-->